/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateEmailTopicOptOut200Response,
  ListTopicOptOuts200Response,
} from '../models/index';
import {
    CreateEmailTopicOptOut200ResponseFromJSON,
    CreateEmailTopicOptOut200ResponseToJSON,
    ListTopicOptOuts200ResponseFromJSON,
    ListTopicOptOuts200ResponseToJSON,
} from '../models/index';

export interface CreateEmailTopicOptOutRequest {
    endpoint: string;
    topic: string;
}

export interface DeleteEmailTopicOptOutRequest {
    endpoint: string;
    topic: string;
}

export interface ListTopicOptOutsRequest {
    endpoint: string;
    pageNumber?: number;
    pageSize?: number;
}

/**
 * 
 */
export class TopicOptOutsApi extends runtime.BaseAPI {

    /**
     * Create email topic opt out
     * Create Email Topic Opt Out
     */
    async createEmailTopicOptOutRaw(requestParameters: CreateEmailTopicOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEmailTopicOptOut200Response>> {
        if (requestParameters['endpoint'] == null) {
            throw new runtime.RequiredError(
                'endpoint',
                'Required parameter "endpoint" was null or undefined when calling createEmailTopicOptOut().'
            );
        }

        if (requestParameters['topic'] == null) {
            throw new runtime.RequiredError(
                'topic',
                'Required parameter "topic" was null or undefined when calling createEmailTopicOptOut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['endpoint'] != null) {
            queryParameters['endpoint'] = requestParameters['endpoint'];
        }

        if (requestParameters['topic'] != null) {
            queryParameters['topic'] = requestParameters['topic'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/topic-opt-out/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmailTopicOptOut200ResponseFromJSON(jsonValue));
    }

    /**
     * Create email topic opt out
     * Create Email Topic Opt Out
     */
    async createEmailTopicOptOut(requestParameters: CreateEmailTopicOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEmailTopicOptOut200Response> {
        const response = await this.createEmailTopicOptOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete email topic opt out
     * Delete Email Topic Opt Out
     */
    async deleteEmailTopicOptOutRaw(requestParameters: DeleteEmailTopicOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEmailTopicOptOut200Response>> {
        if (requestParameters['endpoint'] == null) {
            throw new runtime.RequiredError(
                'endpoint',
                'Required parameter "endpoint" was null or undefined when calling deleteEmailTopicOptOut().'
            );
        }

        if (requestParameters['topic'] == null) {
            throw new runtime.RequiredError(
                'topic',
                'Required parameter "topic" was null or undefined when calling deleteEmailTopicOptOut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['endpoint'] != null) {
            queryParameters['endpoint'] = requestParameters['endpoint'];
        }

        if (requestParameters['topic'] != null) {
            queryParameters['topic'] = requestParameters['topic'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/topic-opt-out/email`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmailTopicOptOut200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete email topic opt out
     * Delete Email Topic Opt Out
     */
    async deleteEmailTopicOptOut(requestParameters: DeleteEmailTopicOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEmailTopicOptOut200Response> {
        const response = await this.deleteEmailTopicOptOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List topic opt outs
     * List Topic Opt Outs
     */
    async listTopicOptOutsRaw(requestParameters: ListTopicOptOutsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTopicOptOuts200Response>> {
        if (requestParameters['endpoint'] == null) {
            throw new runtime.RequiredError(
                'endpoint',
                'Required parameter "endpoint" was null or undefined when calling listTopicOptOuts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['endpoint'] != null) {
            queryParameters['endpoint'] = requestParameters['endpoint'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/topic-opt-out`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTopicOptOuts200ResponseFromJSON(jsonValue));
    }

    /**
     * List topic opt outs
     * List Topic Opt Outs
     */
    async listTopicOptOuts(requestParameters: ListTopicOptOutsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTopicOptOuts200Response> {
        const response = await this.listTopicOptOutsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
